import { cryptoRandomUUID, WidgetNames } from '@finxone-platform/shared/sys-config-types';
import { FormID } from '@finxone-platform/form-action';

export const depositFormChildComponents = [
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.FORM_WIDGET,
    widgetConfiguration: {
      attributes: {
        name: WidgetNames.FORM_WIDGET,
        css_config: {},
        elementsConfig: [],
        widgetProperties: {
          formsConfig: {
            formID: FormID.DEPOSIT_FORM,
            numberOfInputs: '6',
            rowGap: '15px',
            clearFormData: true,
          },
          textContent: '',
        },
      },
      isRemovable: true,
      widgetDisplayName: 'Form',
      widgetConfigDisplayName: 'Form',
    },
    widgetIconPath: 'form-widget',
    childComponents: [
      {
        name: WidgetNames.INPUT_WIDGET,
        uniqueId: cryptoRandomUUID(),
        widgetIconPath: 'input-field-widget',
        widgetTypeConfig: 'new',
        widgetConfiguration: {
          attributes: {
            name: WidgetNames.INPUT_WIDGET,
            css_config: {},
            elementsConfig: [],
            widgetProperties: {
              textContent: '',
              inputFieldConfig: {
                id: 'input-5',
                name: 'amount',
                type: 'text',
                label: ' Amount',
                inputStyle: 'standard',
                parentForm: FormID.DEPOSIT_FORM,
                validation: {
                  email: false,
                  required: true,
                  phoneNumber: false,
                },
                accountType: 'savings-account',
                inputFormat: 'currency-amount',
                searchEnabled: false,
                currencyFormat: 'symbol',
                textStyleClass: 'h6',
                inputHelperText: '',
                inputPlaceholder: '',
                showEmailVerifyButton: false,
                showPhoneVerifyButton: false,
                spaceBetweenElementUnit: 'px',
                spaceBetweenElementValue: '10',
              },
              disableAutocomplete: false,
              parentForm: FormID.DEPOSIT_FORM,
            },
          },
          isRemovable: true,
          nestedWidgets: {},
          widgetDisplayName: 'Input',
          widgetConfigDisplayName: 'Input',
        },
      },
      {
        widgetTypeConfig: 'new',
        uniqueId: cryptoRandomUUID(),
        name: WidgetNames.INPUT_WIDGET,
        widgetConfiguration: {
          widgetDisplayName: 'Input',
          widgetConfigDisplayName: 'Input',
          attributes: {
            elementsConfig: [],
            name: WidgetNames.INPUT_WIDGET,
            css_config: {},
            widgetProperties: {
              textContent: '',
              inputFieldConfig: {
                id: 'input-6',
                type: 'text',
                label: 'Deposit type',
                name: 'depositType',
                validation: {
                  required: true,
                  phoneNumber: false,
                  email: false,
                },
                inputFormat: 'radio',
                fieldRequired: true,
                isPreselectDisabled: false,
                searchEnabled: false,
                showEmailVerifyButton: false,
                inputPlaceholder: '',
                inputHelperText: '',
                inputLabelTooltipText: '',
                spaceBetweenElementUnit: 'px',
                spaceBetweenElementValue: '10',
                radioCheckboxOptionsLayout: 'vertical',
                showPhoneVerifyButton: false,
                defaultCurrency: 'GBP',
                minValue: '0',
                maxValue: '100',
                stepValue: '1',
                sliderValueType: 'percentage',
                options: [
                  {
                    label: 'One-off',
                    value: 'one-off',
                  },
                  {
                    label: 'Recurring',
                    value: 'recurring',
                  },
                ],
                configureAnswerActiveTab: 'Custom',
                parentForm: FormID.DEPOSIT_FORM,
              },
              disableAutocomplete: false,
              parentForm: FormID.DEPOSIT_FORM,
            },
          },
          isRemovable: true,
          nestedWidgets: {},
        },
        widgetIconPath: 'input-field-widget',
      },
    ],
    popupType: 'formWidgetPopup',
  },
];

export const pispRecurringDepositFormChildComponents = [
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-4',
            type: 'select',
            label: 'Repeat',
            parentForm: FormID.PISP_RECURRING_DEPOSIT_FORM,
            name: 'frequency',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            isScrollable: true,
            isScrollPeekEnabled: false,
            visibleItemsCount: 5,
            menuDirection: 'auto',
            inputFormat: 'dropdown',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: '0',
            maxValue: '100',
            stepValue: '1',
            sliderValueType: 'percentage',
            options: [
              {
                label: 'Daily',
                value: 'day',
              },
              {
                label: 'Weekly',
                value: 'week',
              },
              {
                label: 'Bi-Weekly',
                value: 'biweekly',
              },
              {
                label: 'Monthly',
                value: 'month',
              },
            ],
            configureAnswerActiveTab: 'Custom',
          },
          disableAutocomplete: false,
        },
        hideCondition: '',
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-5',
            type: 'select',
            label: 'Collection day',
            parentForm: FormID.PISP_RECURRING_DEPOSIT_FORM,
            name: 'collectionDay',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            isScrollable: true,
            isScrollPeekEnabled: false,
            visibleItemsCount: 5,
            menuDirection: 'auto',
            inputFormat: 'dropdown',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: 'tomorrow',
            maxValue: '1/1/3000',
            stepValue: '1',
            sliderValueType: 'percentage',
            options: [
              {
                label: '1',
                value: '1',
              },
              {
                label: '2',
                value: '2',
              },
              {
                label: '3',
                value: '3',
              },
              {
                label: '4',
                value: '4',
              },
              {
                label: '5',
                value: '5',
              },
              {
                label: '6',
                value: '6',
              },
              {
                label: '7',
                value: '7',
              },
            ],
            configureAnswerActiveTab: 'Custom',
          },
          disableAutocomplete: false,
        },
        hideCondition: '',
        usingResponsiveHideCondition: true,
        responsiveHideCondition:
          "!allFormValues.pispRecurringDepositForm['frequency'] || allFormValues.pispRecurringDepositForm['frequency'] === 'day' || allFormValues.pispRecurringDepositForm['frequency'] === 'month'",
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-6',
            type: 'select',
            label: 'Collection day',
            parentForm: FormID.PISP_RECURRING_DEPOSIT_FORM,
            name: 'collectionDay',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            isScrollable: true,
            isScrollPeekEnabled: false,
            visibleItemsCount: 5,
            menuDirection: 'auto',
            inputFormat: 'dropdown',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: 'tomorrow',
            maxValue: '1/1/3000',
            stepValue: '1',
            sliderValueType: 'percentage',
            options: [
              { label: '1', value: '1' },
              { label: '2', value: '2' },
              { label: '3', value: '3' },
              { label: '4', value: '4' },
              { label: '5', value: '5' },
              { label: '6', value: '6' },
              { label: '7', value: '7' },
              { label: '8', value: '8' },
              { label: '9', value: '9' },
              { label: '10', value: '10' },
              { label: '11', value: '11' },
              { label: '12', value: '12' },
              { label: '13', value: '13' },
              { label: '14', value: '14' },
              { label: '15', value: '15' },
              { label: '16', value: '16' },
              { label: '17', value: '17' },
              { label: '18', value: '18' },
              { label: '19', value: '19' },
              { label: '20', value: '20' },
              { label: '21', value: '21' },
              { label: '22', value: '22' },
              { label: '23', value: '23' },
              { label: '24', value: '24' },
              { label: '25', value: '25' },
              { label: '26', value: '26' },
              { label: '27', value: '27' },
              { label: '28', value: '28' },
              { label: '29', value: '29' },
              { label: '30', value: '30' },
              { label: '31', value: '31' },
            ],
            configureAnswerActiveTab: 'Custom',
          },
          disableAutocomplete: false,
        },
        hideCondition: '',
        usingResponsiveHideCondition: true,
        responsiveHideCondition:
          "!allFormValues.pispRecurringDepositForm['frequency'] || allFormValues.pispRecurringDepositForm['frequency'] === 'day' || allFormValues.pispRecurringDepositForm['frequency'] === 'week' || allFormValues.pispRecurringDepositForm['frequency'] === 'biweekly'",
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-7',
            type: 'select',
            label: 'End date',
            parentForm: FormID.PISP_RECURRING_DEPOSIT_FORM,
            name: 'endDate',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            inputFormat: 'date-picker',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: 'tomorrow',
            maxValue: '',
            stepValue: '1',
            sliderValueType: 'percentage',
            isScrollable: true,
            isScrollPeekEnabled: false,
            visibleItemsCount: 5,
            menuDirection: 'auto',
            dateFormat: 'input',
            day: 'day-1',
            month: 'month-1',
            year: 'year-1',
          },
          disableAutocomplete: false,
        },
        hideCondition: '',
        usingResponsiveHideCondition: true,
        responsiveHideCondition:
          "!allFormValues.pispRecurringDepositForm['frequency'] || allFormValues.pispRecurringDepositForm['frequency'] !== 'day'",
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
];
